import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import ProductBasket from '../../../../components/pages/basket/components/productBasket';
import ProductCarousel from '../../../../components/pages/basket/components/productCarousel';
import { filteredSideOrders } from '../../../../components/pages/firstStep/helpers/firstStepHelpers';
import { useAppDispatch, useAppSelector } from '../../../../config/hooks';
import { storeSideOrders } from '../../../../redux/actions/sideOrdersActions';
import { getAdditionalFees } from '../../../../redux/selectors/basketSelector';
import { useGetApiSideOrdersQuery } from '../../../../services/api/form/open/open.api';
import { getServerConfig } from '../../../general/generalSlice';

const OneOffSideOrders = () => {
  const dispatch = useAppDispatch();

  const { companyId } = useAppSelector(getServerConfig);
  const additionalFee = useAppSelector(getAdditionalFees);
  const { availableFees, selectedFees } = additionalFee || {};

  const { data: sideOrders } = useGetApiSideOrdersQuery(undefined, {
    skip: !companyId,
  });

  useEffect(() => {
    if (sideOrders && sideOrders?.length > 0) {
      dispatch(storeSideOrders(sideOrders));

      dispatch(filteredSideOrders(sideOrders));
    }
  }, [dispatch, selectedFees, sideOrders]);

  return (
    <>
      <AnimatePresence>
        {!!selectedFees?.length && (
          <motion.div
            animate={{
              opacity: 1,
              height: 'auto',
            }}
            exit={{
              opacity: 0,
              height: 0,
            }}
            initial={{
              opacity: 0,
              height: 'auto',
            }}
            transition={{ duration: 0.3 }}
          >
            <ProductBasket additionalFeeList={selectedFees} />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {!!availableFees?.length && (
          <motion.div
            animate={{
              opacity: 1,
              height: 'auto',
            }}
            exit={{
              opacity: 0,
              height: 0,
            }}
            initial={{
              opacity: 0,
              height: 'auto',
            }}
            transition={{ duration: 0.3 }}
          >
            <ProductCarousel additionalFee={additionalFee} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default OneOffSideOrders;
